import { createMessage, getMessageDt } from '~/helpers/backendHelper';
import { takeEvery, put, call } from 'redux-saga/effects';
import { createMessageErr, createMessageOk, getMessageDtErr, getMessageDtOk } from './actions';
import { CREATE_MESSAGE, GET_MESSAGE_DT } from './actionTypes';
import EventEmitter from '~/helpers/eventsHelper';

function* onGetMessageDt({ payload: { params } }) {
  try {
    const response = yield call(getMessageDt, params);
    yield put(getMessageDtOk(response))
  } catch (error) {
    yield put(getMessageDtErr(error))
  }
}

function* onCreateMessage({ payload: { data } }) {
  let config = null;
  if (data instanceof FormData) {
    config = {
      onUploadProgress: ev => EventEmitter.emit('message.uploadProgress', { ev, fileUid: data.get('uid') })
    };
  }
  try {
    const response = yield call(createMessage, data, config);
    yield put(createMessageOk(response));
  } catch (error) {
    yield put(createMessageErr(error));
  }
}

function* messagesSaga() {
  yield takeEvery(GET_MESSAGE_DT, onGetMessageDt);
  yield takeEvery(CREATE_MESSAGE, onCreateMessage);
}

export default messagesSaga;